import { render, staticRenderFns } from "./ModifierDisplay.vue?vue&type=template&id=62fbf445&scoped=true"
import script from "./ModifierDisplay.vue?vue&type=script&lang=js"
export * from "./ModifierDisplay.vue?vue&type=script&lang=js"
import style0 from "./ModifierDisplay.vue?vue&type=style&index=0&id=62fbf445&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fbf445",
  null
  
)

export default component.exports